import type { IAddress } from '@/types/address';
import type { IAgency } from '@/types/agency';
import type { DataSet, DB, ObjectID, Timestamp } from '@/types/common';
import type {
	IWorkerJob,
	JobExperience,
	JobService,
	JobServiceStatus,
} from '@/types/job';
import type { IMission } from '@/types/mission';
import type {
	CandidateStatus,
	CV,
	ICandidateDB,
	InactiveByAgencies,
	IOfferApplication,
	IWorkerAgency,
} from '@/types/worker';

export enum JobOfferStatus {
	DRAFT = 'DRAFT',
	PUBLISHED = 'PUBLISHED',
	UNPUBLISHED = 'UNPUBLISHED',
}

export enum JobOfferPublicationStatus {
	PUBLISHED = 'PUBLISHED',
	NOT_PUBLISHED = 'NOT_PUBLISHED',
	OLD = 'OLD',
}

export interface JobOfferCandidates {
	idCandidate: ObjectID;
	status: string;
}

export type JobServiceConfiguration = {
	jobBoards: Array<string>;
	active: boolean;
	activationDate?: Timestamp;
	status?: JobServiceStatus;
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	offer?: any;
};

export interface IJobOffer {
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	stats?: any;
	agencyId: ObjectID;
	ownerId: ObjectID;
	name: string;
	availableCommands?: string[];
	nameSlug?: string;
	services: DataSet<JobServiceConfiguration>;
	jobId: ObjectID;
	experience?: JobExperience | null;
	address: Partial<IAddress>;
	region?: string;
	department?: string;
	description: string;
	missionId?: ObjectID;
	clientId?: ObjectID;
	status?: JobOfferStatus;
	mission?: IMission;
	timestamp?: DataSet<Timestamp>;
	missionStartDate?: Timestamp;
	businessSectors?: Array<string>;
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	businessSectorFull?: any;
	functions?: Array<string>;
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	jobs?: any;
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	job?: any;
	jobType: string;
	jobContract: string;
	jobStatus: string;
	jobDuration: string;
	applicantProfile: string;
	reference?: string;
	applicantDegree?: string;
	applicantExperience?: string;
	salaryFrom?: string;
	salaryTo?: string;
	salaryPer?: string;
	salaryCurrency?: string;
	offerUrl?: string;
	offerUrlEdit?: string;
	candidates: Array<JobOfferCandidates>;
	postingDate?: Timestamp;
	workerIds: string[];
}

export interface IJobOfferDB extends IJobOffer, DB {}

export interface IJobOfferMission {
	id?: ObjectID;
	name?: string;
	status?: JobOfferStatus;
	workerToTreated?: number;
	createdAt?: Timestamp;
}

export interface IJobOffersWorker extends ICandidateDB {
	id: ObjectID | string;
	firstname: string;
	lastname: string;
	addedToJobOfferAt: Timestamp;
	isInterim: boolean;
	statusInJobOffer: string;
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	globalStatus: any;
	phone: string;
	sourceInJobOffer: JobService[];
	candidateStatus: CandidateStatus;
	origin: string;
	agencies: ({
		agencyName: string;
		profileStatus: string;
		candidateStatus: CandidateStatus;
		agencyId: string;
	} & IAgency &
		IWorkerAgency)[];
	createdAt: number;
	isIdentification?: boolean;
	cv: CV;
	jobs: IWorkerJob[];
	address: IAddress;
	email: string;
	isVehicle: boolean;
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	availableCommands: any;
	offerApplications: IOfferApplication[];
	rejectedReason: string;
	workerId?: ObjectID | string;
	inactiveByAgencies?: InactiveByAgencies;
}
